// ThemeColorContext.tsx
import { createContext, useContext, useState, useEffect, ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { COLORS, setThemeColorByModelName } from "../../constants/ColorsData";
import { BLOCK_VALUE_KEY_LAST_SELECTED, CURRENT_COLOR_THEME_USED } from "../../constants/StoreKey";
import { decryptData } from "../../utils/util_function";
import { saveData4Theme } from "./ThemeFunction";

type ThemeColorContextType = {
    currentThemeColor: string;
    setCurrentThemeColor: (color: string) => void;
};

const ThemeColorContext = createContext<ThemeColorContextType | undefined>(undefined);

export const ThemeColorProvider = ({ children }: { children: ReactNode }) => {
    const location = useLocation();

    const getInitialColor = (): string => {
        const stored = decryptData(CURRENT_COLOR_THEME_USED);
        return stored ?? COLORS.grisSombre;
    };

    const [currentThemeColor, setCurrentThemeColor] = useState(getInitialColor);

    useEffect(() => {
        const stored = decryptData(CURRENT_COLOR_THEME_USED);
        const ls_last_theme_data = decryptData(BLOCK_VALUE_KEY_LAST_SELECTED);

        if (ls_last_theme_data) {
            document.documentElement.style.setProperty('--current-theme-color', ls_last_theme_data.color);
            document.documentElement.style.setProperty('--current-theme-color-check', ls_last_theme_data.color);
        }

        if (stored && stored !== currentThemeColor) {
            setCurrentThemeColor(stored);
        }
    }, [location.pathname]);

    useEffect(() => {
        saveData4Theme(currentThemeColor);
    }, [currentThemeColor]);

    return (
        <ThemeColorContext.Provider value={{ currentThemeColor, setCurrentThemeColor }}>
            {children}
        </ThemeColorContext.Provider>
    );
};

export const useThemeColor = () => {
    const context = useContext(ThemeColorContext);
    if (!context) throw new Error("useThemeColor must be used within a ThemeColorProvider");
    return context;
};